import Marquee from "react-fast-marquee";

export default function TextMarquee({ inverted = false }) {
  const words = ["GOOD GRIEF", "WORLDWIDE", "DROP 01", "COMING SOON", "EST. GRIEF"];
  return (
    <div
      className={`py-6 border-y-2 ${
        inverted ? "bg-[#090909] border-[#F2EFEB]" : "bg-[#F2EFEB] border-[#090909]"
      }`}
      data-testid="text-marquee"
    >
      <Marquee speed={30} gradient={false}>
        {words.map((w, i) => (
          <span
            key={i}
            className={`font-display text-6xl md:text-8xl mx-8 ${
              inverted ? "text-outline-bone" : "text-outline"
            }`}
          >
            {w} <span className="mx-4">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
